import "../components/loader/index";
// seq code
const homepage_recipe = async () => {
  console.info("Homepage recipe");
};

homepage_recipe();
